












































































































































































































































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class NotificationsHelp extends Vue {
  tab = null;
}
